import store from '../store';
import AdTypes from './adTypes';

class AdEngine {

    constructor() {
        this.notRandomNumbers = [1, 1, 1, 1, 1, 1, 1, 1, 2, 2];
    }

    randomWithProbabilityForAd() {
        let idx = Math.floor(Math.random() * this.notRandomNumbers.length);
        return this.notRandomNumbers[idx];
    }

    getAdTypeIdByName(adTypeName) {
        return AdTypes.find((adType) => adType.name === adTypeName).id;
    }
    
    includeHideAdsWL() {
        return store.state.whitelabel.features.findIndex((feature) =>
            feature.feature.name === "HIDE_SWISET_ADDS") !== -1;
    }
    getRandomAd(adTypeName) {
        if(store.state.user.isPro || this.randomWithProbabilityForAd() !== 1)
            return null; // Ad skipped
        if(store.state.whitelabel.partner !== null && this.includeHideAdsWL()){ // embedded
            return null;
        }

        let typeId = this.getAdTypeIdByName(adTypeName);
        let possibleAds = store.state.ads.filter((ad) => ad.adType.id === typeId);
        return possibleAds[Math.floor(Math.random() * possibleAds.length)];
    }
}

export default new AdEngine();
